import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store

import PropTypes from 'prop-types';
import Input from 'react-toolbox/lib/input'; // to use input from react-toolbox library
import AutoComplete from 'react-toolbox/lib/autocomplete';
import Switch from 'react-toolbox/lib/switch';
import { states } from 'constants/DropdownsValues';
import AddVideo from 'components/AddVideos';
import Error from 'components/ErrorMessage';

import renderIf from 'render-if'; // to use conditional rendering based on values that is provided to component
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { selector } from '../../containers/Profile-view/redux';
import { saveSAProfile } from '../GetUserDetails/actions';
import { getSAProfile, saveUserImage, videoDetails, setCurrentVideo, removeVideo } from '../../containers/Profile-view/actions';


import styles from './style.scss'; // to import local scss fle

class Info extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    saveSAProfile: PropTypes.func,
    item: PropTypes.shape(),
    removeVideo: PropTypes.func,
    videoDetails: PropTypes.func,
    saveUserImage: PropTypes.func.isRequired,
  };
  static defaultProps = {
    item: {},
    saveSAProfile: () => {},
    removeVideo: () => {},
    videoDetails: () => {},
    history: {
      push: () => {},
    },
  };
  constructor(props) {
    super(props);
    // this.onOpenModal = this.onOpenModal.bind(this);
    // this.onCloseModal = this.onCloseModal.bind(this);
    this.state = {
      // id: this.props.item.get('id'),
      open: true,
      openDelete: false,
      switchMails: false,
      title: '',
      userImage: '',
      sa_state: '',
      sa_twitter: '',
      currentVideo: '',
      changeImage: false,
      errorMessage: '',
      video: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.onMouseHover = this.onMouseHover.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.handleChangeImage = this.handleChangeImage.bind(this);
  }
  componentWillReceiveProps(nextProp) {
    if (nextProp.item.switchMails !== undefined) {
      this.setState({ switchMails: nextProp.item.switchMails });
    } else {
      this.setState({ switchMails: true });
    }
    this.setState({ video: nextProp.item.video_items || [],
      sa_state: nextProp.item.state,
      sa_twitter: nextProp.item.sa_twitter,
    });
  }

  onMouseHover() {
    this.setState({ changeImage: true });
  }

  onMouseOut() {
    this.setState({ changeImage: false });
  }

  removeVideo = (index) => {
    const data = {
      student_id: this.props.item.id,
      video_index: index,
    };
    this.props.removeVideo(data, () => {
      this.setState({
        video: this.state.video.filter((item, i) => i !== index),
        openDelete: false,
      });
    });
  };

  saveVideo = (videoData) => {
    this.props.videoDetails(videoData, (newVideos) => {
      this.setState({ video: [...newVideos.toJS()] });
    });
  }
  handleChange(name, value) {
    this.setState({ ...this.state, [name]: value });
  }

  handleChangeImage(event) {
    const reader = new window.FileReader();
    const file = event.target.files[0];
    reader.onloadend = () => {
      this.setState({
        userImage: reader.result,
      });
    };
    reader.readAsDataURL(file);
    // this.setState({ userImage: image });
    this.props.saveUserImage(this.props.item.id, file);
  }

  Close = () => {
    this.props.close();
    // this.setState({ video: [],
    //   sa_state: '',
    //   sa_twitter: '',
    // });
  }

  validateInput = () => {
    const payload = {};
    const { sa_twitter, sa_state, switchMails } = this.state;
    // eslint-disable-next-line camelcase
    if (sa_twitter) {
      let twitterUrl = '';
      if (sa_twitter.startsWith('https')) {
        // eslint-disable-next-line camelcase
        twitterUrl = sa_twitter;
      } else {
        // eslint-disable-next-line camelcase
        twitterUrl = `https://twitter.com/${sa_twitter}`;
      }

      // eslint-disable-next-line camelcase
      payload.sa_twitter = twitterUrl;
    }
    // eslint-disable-next-line camelcase
    if (sa_state) {
      // eslint-disable-next-line camelcase
      payload.sa_state = sa_state;
    }
    payload.switchMails = switchMails;
    payload.id = this.props.item.id;
    this.props.saveSAProfile(payload, this.props.item.id, (error) => {
      if (error) {
        this.setState({ errorMessage: 'Failed to save' });
      } else {
        this.props.close();
        // this.setState({
        //   video: [],
        //   sa_state: '',
        //   sa_twitter: '',
        // });
      }
    });
  }
  render() {
    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
      },
      content: {
        width: '80%',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        paddingTop: '50px',
        height: '500px',
        transform: 'translate(-50%, -50%)',
      },
    };
    const modalStyleText = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
      },
      content: {
        width: '40%',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        paddingTop: '50px',
        height: '200px',
        transform: 'translate(-50%, -50%)',
      },
    };
    const { openDelete, currentVideo, video, sa_state, sa_twitter } = this.state;
    const studentVideo = video;
    const { open, item } = this.props;
    // const video = item.get('video_items');
    // eslint-disable-next-line no-console
    const renderChangeImage = renderIf(this.state.changeImage);
    return (
      <div>
        {/* eslint-disable */}

        <Modal
          style={modalStyle}
          isOpen={open}
          onRequestClose={this.onCloseModal}
        >
          <h2 className={styles.confirmText} style={{ marginLeft: 30 }}>EDIT ATHLETE DETAILS</h2>
          <div className={cn("col s12", styles.imageHeader)}>
            {/* <div className={cn("row", styles.popupContainer)}> */}
              <div
                className={styles.image}
                onMouseOver={this.onMouseHover}
                onMouseOut={this.onMouseOut}
              >
                {this.state.userImage !== "" ? (
                  <img
                    className={styles.image}
                    src={this.state.userImage}
                    alt="user_image"
                  />
                ) : (
                  <img
                    className={styles.image}
                    src={
                      this.props.profile_image && this.props.profile_image !== ""
                        ? `https://s3.amazonaws.com/myrbimages/${item.
                            profile_image
                          }`
                        : "https://media.dev.myrecruitboard.com/Images/defaultAthlete.png"
                    }
                    alt="profile"
                  />
                )}
                {renderChangeImage(
                  <div className={styles.changeImage}>
                    <div className={styles.changeImageText}>change image.</div>
                  </div>
                )}
                <form>
                  <input
                    className={styles.fileInput}
                    type="file"
                    ref="file" //eslint-disable-line
                    name="myImage"
                    accept=".jpg,.jpeg"
                    onChange={this.handleChangeImage}
                  />
                </form>
              </div>
              </div>
              <hr></hr>
              <div className={cn("col s12")} style={{ display: 'flex' }}>
              <div style={{ marginRight: 80 }}>
              <span>STATE</span>
                <AutoComplete
                  source={states}
                  onQueryChange={val => this.handleChange('sa_state', val)}
                  selectedPosition="below"
                  direction="down"
                  value={sa_state}
                  allowCreate
                  multiple={false}
                  onChange={val => this.handleChange('sa_state', val)}
                  onFocus={() => this.removeValue('stateErrorMessage')}
                  className={styles.autocomplete}
                />
                {/* <Error message={stateErrorMessage} /> */}
              </div>
              <div style={{ marginRight: 50 }}>
              <span>TWITTER LINK</span>
              <Input
                className={styles.autoInput}
                // value={item.get('sa_twitter')}
                type="text"
                name="sa_twitter"
                value={sa_twitter}
                // onFocus={() => this.removeErrorMessage('twitterErrorMessage')}
                onChange={val => this.handleChange('sa_twitter', val)}
                style={{ marginTop: 12 }}
              />
            </div>
            </div>
            <hr></hr>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {studentVideo && studentVideo.map((item, i) => 
              <div key={i} className={cn('col  s6 ', styles.videoBox)}>
              <div className={styles.video}>
                <button onClick={() => this.setState({ openDelete: true, currentVideo: i })} className={styles.editIcon}>
                  <img src="https://media.dev.myrecruitboard.com/Images/white_delete.png" alt="edit-icon" />
                </button> 
                <img className={styles.videoImage} src={item.thumbnail_url} alt="thumbnail" />
                  <button className={styles.playbutton} >
                    <a href={item.video_url} target="_blank" rel="noopener noreferrer" >
                      <img className={styles.playButtonImage} src="https://media.dev.myrecruitboard.com/Images/video-icon_3%403x.png" alt="video" />
                    </a>
                  </button>
                  {/* eslint-enable*/}
              </div>
                <div className={styles.titile}>{item.video_title}</div>
              </div>,
              )}
            </div>
          <AddVideo videoDetails={this.saveVideo} profileId={item.id} />
          <hr />
          <Switch
            checked={this.state.switchMails}
            label="Stop Sending Mail To Coaches"
            onChange={val => this.handleChange('switchMails', val)}
          />
          <Error message={this.state.errorMessage} />
          <div className={cn('col s12')} style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              className={styles.buttonContainer}
              onClick={this.validateInput} style={{ margin: 10 }}
            >SAVE</button>
            <button
              className={styles.buttonClose}
              onClick={this.Close} style={{ margin: 10 }}
            >CLOSE</button>
          </div>
          {/* </div> */}
          {/* eslint-disable */}
        </Modal>
        <Modal
          style={modalStyleText}
          isOpen={openDelete}
          onRequestClose={this.onCloseModal}
        >
          <h1 className={styles.confirmText} style={{ marginLeft: 30 }}>Please confirm before deleting permanently</h1>
        <div className={cn('col s12')} style={{ display: 'flex', justifyContent: 'center' }}>
          <button className={styles.buttonContainer} onClick={() => this.removeVideo(currentVideo)} style={{ margin: 10 }}>DELETE</button>
          <button className={styles.buttonClose} onClick={() => this.setState({ openDelete: false })} style={{ margin: 10 }}>CLOSE</button>
        </div>
        </Modal>
      </div>
    );
  }
}

export default connect(selector,
  { getSAProfile,
    saveSAProfile,
    saveUserImage,
    videoDetails,
    setCurrentVideo,
    removeVideo,
  })(Info);



// WEBPACK FOOTER //
// ./src/components/AtheletePopup/AtheletePopup.js